import type moment from 'moment';

import { MED_DATE_ONLY_DISPLAY, formatDateTimeDisplay, momentWithUserTimezone } from 'js/utils/DateTimeUtils';

class WeekRange {
  weekStartDate: moment.Moment;

  weekEndDate: moment.Moment;

  constructor({ weekStartDate, weekEndDate }: { weekStartDate: moment.Moment; weekEndDate: moment.Moment }) {
    this.weekStartDate = weekStartDate;
    this.weekEndDate = weekEndDate;
  }

  isThisWeekDisabled(): boolean {
    return this.weekStartDate.valueOf() === momentWithUserTimezone().startOf('week').valueOf();
  }

  areSameMonth(): boolean {
    return momentWithUserTimezone(this.weekStartDate).month() === momentWithUserTimezone(this.weekEndDate).month();
  }

  areSameYear(): boolean {
    return momentWithUserTimezone(this.weekStartDate).year() === momentWithUserTimezone(this.weekEndDate).year();
  }

  getFormattedDate(): string {
    const momentStartDate = momentWithUserTimezone(this.weekStartDate).clone();
    const momentEndDate = momentWithUserTimezone(this.weekEndDate).clone();

    let startDate = '';
    let endDate = '';

    if (this.areSameYear() && this.areSameMonth()) {
      startDate = formatDateTimeDisplay(momentStartDate, 'MMMM D');
      endDate = formatDateTimeDisplay(momentEndDate, 'D, YYYY');
    } else if (this.areSameYear() && !this.areSameMonth()) {
      startDate = formatDateTimeDisplay(momentStartDate, 'MMM D');
      endDate = formatDateTimeDisplay(momentEndDate, 'MMM D, YYYY');
    } else if (!this.areSameYear()) {
      startDate = formatDateTimeDisplay(momentStartDate, MED_DATE_ONLY_DISPLAY);
      endDate = formatDateTimeDisplay(momentEndDate, MED_DATE_ONLY_DISPLAY);
    }
    return `${startDate} - ${endDate}`;
  }
}

export default WeekRange;
